module.exports = __webpack_public_path__ + "img/download_img.f04e8d46.png";